import styled from '@emotion/styled';

import type { TWarningStyleConfig } from './warning.types';

export const WebSection = styled.section<TWarningStyleConfig>`
	width: ${props => (props.newChat ? '100%' : '313px')};
	left: 339px;
	top: 257px;
	padding: 10px;
	margin: ${props => (props.newChat ? '10px' : '55px 0 0')};

	${({ index, marginTop }) => (index === 0 ? `margin-top: ${marginTop}px !important;` : '')};

	background: #ff0032;
	border-radius: 8px;

	h4,
	p {
		color: #fff;
		font-size: 14px;
		line-height: 150%;
	}

	@media (min-width: 991px) {
		width: 503px;
		display: flex;
		justify-content: space-between;
		margin-top: ${props => (props.newChat ? '10px' : '55px')};
	}
`;

export const WebImageWrap = styled.figure`
	padding: 10px;
	display: none;
	margin-right: 10px;

	@media (min-width: 991px) {
		display: block;
	}
`;
